module.exports = __webpack_public_path__ + "static/media/SmartPub-calendar-range-icon.9fd81afc.svg";